import { useOutletContext } from 'react-router-dom'
import type { TenantDetail, TenantTab } from '@/api/types'
import { invalidateQueries, setQueryData } from '@/lib/query'

export const TAB_LABELS: Record<TenantTab, string> = {
  overview: 'Overview',
  settings: 'Settings',
  domains: 'Domains',
  plan: 'Plan & billing',
  'add-ons': 'Add-ons',
  sports: 'Sports',
  fees: 'Fees',
  people: 'People',
  activity: 'Activity',
  'danger-zone': 'Danger zone',
}

export interface TenantContext {
  tenant: TenantDetail
  /** Refetch the tenant (and the tenant list) after a write that didn't return it. */
  reload: () => void
  /**
   * Adopt the `{ tenant }` a write returned: every tab re-renders with the
   * server's state at once, and lists and the dashboard refetch.
   */
  apply: (tenant: TenantDetail) => void
}

export function useTenant(): TenantContext {
  return useOutletContext<TenantContext>()
}

/** Query key for one tenant's detail. */
export const tenantKey = (id: number) => ['tenant', id] as const

export function applyTenant(tenant: TenantDetail) {
  setQueryData(tenantKey(tenant.id), tenant)
  invalidateQueries('tenants')
  invalidateQueries('dashboard')
}

export function reloadTenant() {
  invalidateQueries('tenant')
  invalidateQueries('tenants')
  invalidateQueries('dashboard')
}
